var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76953 1C6.76953 1 6.40893 1.3606 4.09084 3.67869C1.77275 5.99678 1.00005 6.76948 1.00005 6.76948",
    stroke: "#1F1F1F",
    strokeWidth: 1.7201
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C1 1 1.3606 1.3606 3.67869 3.67869C5.99678 5.99678 6.76948 6.76948 6.76948 6.76948",
    stroke: "#1F1F1F",
    strokeWidth: 1.7201
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCrossIcon);
export default __webpack_public_path__ + "static/media/blackCrossIcon.b13ff9df342af2f3842442c0e8d4a9c5.svg";
export { ForwardRef as ReactComponent };